import React from 'react';
import { FormattedMessage } from 'react-intl';
import { IconUiMooDropFill } from 'moods-react/Icons';
import messages from '../../../data/footer';

import './Footer.scss';

const FooterComponent = ({ selectedStoreCode }) => (
  <footer className="footer-component u-display-flex u-fontSize-xs">
    <div className="footer-component__copyright">
      <IconUiMooDropFill className="moo-drop-icon -medium u-color-moogreen" />
      <span>
        <FormattedMessage {...messages.footerCompanyAddressLine1} />
        <FormattedMessage {...messages.footerCompanyAddressLine2} />
        <FormattedMessage {...messages.footerCompanyAddressLine3} />
      </span>
    </div>
    <div className="footer-component__links">
      <a href="/about/fonts.html">
        <FormattedMessage {...messages.footerLinkFonts} />
      </a>
      <a href={`/${selectedStoreCode}/business-printing-services/terms-conditions.html`}>
        <FormattedMessage {...messages.footerLinkTerms} />
      </a>
      <a href={`/${selectedStoreCode}/about/privacy-policy.html`}>
        <FormattedMessage {...messages.footerLinkPolicy} />
      </a>
      {/* 'Cookie Preferences' link */}
      <span id="teconsent" />
    </div>
  </footer>
);

FooterComponent.displayName = 'Footer';

export default FooterComponent;
